import { useSelector } from "react-redux";
import { selectProductData } from "~/domains/product/redux/selectors";
import { type SrpProductData } from "~/utils/models";
import { useAddProductToWishlistFlow } from "~/features/wishlist/hooks/useAddProductToWishlistFlow";
import { useCallback } from "react";
import { ActionIconButton } from "~/common/components/Button/ActionIconButton";
import BookmarkIcon from "@mui/icons-material/Bookmark";

export const AddToWishlistAction = ({ productCode, ...rest }: { productCode: string }) => {
  const product = useSelector(selectProductData(productCode)) as SrpProductData;
  const [addToWishlistClick, addToWishlistModal] = useAddProductToWishlistFlow({ productInput: product });

  const openWishlist = useCallback(() => {
    addToWishlistClick();
  }, [addToWishlistClick]);

  return (
    <>
      <ActionIconButton
        data-test-id={"tabular-view-action-button-wishlist"}
        icon={<BookmarkIcon  />}
        inverted={true}
        onIconClick={openWishlist}
        {...rest}
      />
      {addToWishlistModal}
    </>
  );
};
